import { getEnvVariable } from '../utils/getEnvVariable'

export const debug = true // getEnvVariable('REACT_APP_DEBUG') === 'true' || false
export const mock = (): string | boolean => getEnvVariable('REACT_APP_MOCK_REQUESTS') === 'true' || false
